type QuestionType = "single" | "multi" | "text";
type Question = {
  id: string;
  type: QuestionType;
  label: string;
  options?: string[];
  required?: boolean;
};
type SurveyTemplate = {
  slug: string;
  name: string;
  version: number;
  questions: Question[];
};

export const BRE_SURVEY_TEMPLATES: SurveyTemplate[] = [
  {
    slug: "business-retention-expansion",
    name: "Business Retention & Expansion",
    version: 1,
    questions: [
      {
        id: "q1",
        type: "single",
        label:
          "How would you rate the availability of qualified workers in your area?",
        options: ["5 - Excellent", "4", "3", "2", "1 - Very Poor"],
        required: true,
      },
      {
        id: "q2",
        type: "single",
        label:
          "Are you currently hiring or planning to hire in the next 6 to 12 months?",
        options: ["Yes", "No"],
        required: true,
      },
      {
        id: "q3",
        type: "single",
        label: "How would you rate the local business climate?",
        options: ["5 - Excellent", "4", "3", "2", "1 - Very Poor"],
        required: true,
      },
      {
        id: "q4",
        type: "single",
        label:
          "Are you considering a facility expansion, relocation, or new site development in the next 1 to 3 years?",
        options: ["Yes", "No", "Maybe"],
      },
      {
        id: "q5",
        type: "single",
        label:
          "How would you describe your business performance over the past 12 months?",
        options: ["Growing", "Stable", "Declining"],
      },
      {
        id: "q6",
        type: "multi",
        label: "What are your projected growth plans in the next 1 to 3 years?",
        options: [
          "Increase in Workforce",
          "Expansion of Physical Space",
          "Entering New Markets",
          "Launching New Products/Services",
          "No Significant Growth Planned",
        ],
      },
      {
        id: "q7",
        type: "multi",
        label:
          "What infrastructure improvements would benefit your business most?",
        options: [
          "Roads/Transportation",
          "Broadband/Technology",
          "Utilities (electric, water, gas)",
        ],
      },
      {
        id: "q8",
        type: "multi",
        label: "What are the biggest barriers to growth for your business?",
        options: [
          "Workforce Shortage",
          "Cost of Real Estate",
          "Access to Capital",
          "Supply Chain Issues",
          "Local Regulations",
          "Other",
        ],
      },
      {
        id: "q9",
        type: "single",
        label:
          "How satisfied are you with the support you receive from local government or economic development organizations?",
        options: [
          "Very Satisfied",
          "Somewhat Satisfied",
          "Neutral",
          "Somewhat Dissatisfied",
          "Very Dissatisfied",
        ],
      },
      {
        id: "q10",
        type: "multi",
        label:
          "Which of the following services would be most helpful to your business?",
        options: [
          "Workforce Training Programs",
          "Business Incentives",
          "Export Assistance",
          "Site Selection Support",
          "Permitting Assistance",
          "Networking & Collaboration Opportunities",
        ],
      },
      {
        id: "q11",
        type: "single",
        label:
          "Are workforce training or upskilling programs needed in your industry?",
        options: ["Yes", "No", "Not Sure"],
      },
      {
        id: "q12",
        type: "multi",
        label: "What types of occupations are hardest to fill in your company?",
        options: [
          "Skilled Trades",
          "Engineering/Technical",
          "Administrative",
          "Sales/Marketing",
          "Entry-Level",
          "Other",
        ],
      },
      {
        id: "q13",
        type: "single",
        label: "Are you facing supply chain disruptions?",
        options: ["Yes, frequently", "Occasionally", "No", "Not Applicable"],
      },
    ],
  },
  {
    slug: "general-economic-development",
    name: "General Economic Development Survey",
    version: 1,
    questions: [
      {
        id: "q1",
        type: "multi",
        label: "What are the biggest economic challenges facing your region?",
        options: [
          "Workforce",
          "Housing",
          "Infrastructure",
          "Capital Access",
          "Other",
        ],
      },
      {
        id: "q2",
        type: "single",
        label: "How effective are current economic development programs?",
        options: [
          "Very Effective",
          "Somewhat Effective",
          "Neutral",
          "Ineffective",
        ],
      },
      {
        id: "q3",
        type: "multi",
        label: "What types of businesses would you like to see more of?",
        options: [
          "Manufacturing",
          "Retail",
          "Technology",
          "Healthcare",
          "Tourism",
        ],
      },
      {
        id: "q4",
        type: "multi",
        label:
          "Which types of incentives would be most beneficial to attract or retain businesses in your area?",
        options: [
          "Tax Credits",
          "Training Subsidies",
          "Infrastructure Investment",
          "Low-Interest Loans",
          "Site Development Grants",
        ],
      },
      {
        id: "q5",
        type: "single",
        label:
          "What should be the top priority for economic development in your region?",
        options: [
          "Job Creation",
          "Industry Diversification",
          "Housing Development",
          "Business Attraction",
          "Workforce Training",
          "Quality of Life Improvements",
        ],
      },
      {
        id: "q6",
        type: "single",
        label:
          "How would you rate the collaboration among local stakeholders (businesses, government, education, etc.)?",
        options: ["Excellent", "Good", "Fair", "Poor", "Unsure"],
      },
      {
        id: "q7",
        type: "single",
        label:
          "Do you believe your region has a strong brand or identity that supports economic growth?",
        options: ["Yes", "No", "Unsure"],
      },
      {
        id: "q8",
        type: "multi",
        label:
          "Which population segments are most underserved in your local economy?",
        options: [
          "Youth / Young Adults",
          "Veterans",
          "Low-Income Residents",
          "Minority-Owned Businesses",
          "Rural Communities",
          "Other",
        ],
      },
    ],
  },
];
